import {
  ElementVerticalAlignType,
  FontStyleType,
  PositionType,
  SizeType
} from './../types/common.types';

export interface CSSProperties {
  backgroundColor?: string;
  goldBackgroundColor?: string;
  platinumBackgroundColor?: string;
  reserveBackgroundColor?: string;
  background?: string;
  border?: BorderStyle;
  borderColor?: string;
  color?: string;
  fontColor?: string;
  fontSize?: string;
  fontStyle?: FontStyleType;
  fontType?: string;
  fontWeight?: string;
  lineHeight?: string;
  position?: PositionType;
  zIndex?: number;
  width?: number | SizeType | string;
  verticalAlign?: ElementVerticalAlignType;
  letterSpacing?: string;
}

export interface StylesContent extends CSSProperties {
  message: string;
}

/** Generic border style with shorthand included */
export interface BorderStyle {
  border?: string;
  'border-top'?: string;
  'border-right'?: string;
  'border-bottom'?: string;
  'border-left'?: string;
}

export interface HeaderStyles {
  content?: CSSProperties;
  link?: CSSProperties;
  closeIcon?: CSSProperties;
}

export interface BodyStyles {
  content?: CSSProperties;
  container?: CSSProperties;
}
